import React, { useEffect, useMemo, useRef } from 'react';
import type { Location } from '../api/types';
import L from 'leaflet';

export function MapPreview({ loc }: { loc: Location }) {
  const ref = useRef<HTMLDivElement|null>(null);
  const id = useMemo(() => `map_${Math.random().toString(16).slice(2)}`, []);

  useEffect(() => {
    if (!ref.current) return;
    const map = L.map(ref.current, { zoomControl: false, attributionControl: false }).setView([loc.lat, loc.lon], 15);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);
    L.marker([loc.lat, loc.lon]).addTo(map);
    return () => { map.remove(); };
  }, [id, loc.lat, loc.lon]);

  return (
    <div style={{ display:'grid', gap: 8 }}>
      <div ref={ref} style={{ height: 160, borderRadius: 12, overflow:'hidden' }} />
      <div className="small">
        {loc.address ? loc.address : `Lat ${loc.lat.toFixed(5)}, Lon ${loc.lon.toFixed(5)}`}
        {' · '}
        <a href={`https://www.openstreetmap.org/?mlat=${loc.lat}&mlon=${loc.lon}#map=18/${loc.lat}/${loc.lon}`} target="_blank" rel="noreferrer">Apri in OSM</a>
      </div>
    </div>
  );
}
